<template>
  <button
    v-if="show"
    type="button"
    :class="buttonClass"
    :disabled="disabled"
    @click.stop="handleClick"
  >
    <span class="icon"><i class="fas fa-trash"></i></span>
    <span>{{ label }}</span>
  </button>
</template>

<script setup>
  import { inject, computed } from "vue";

  const props = defineProps({
    show: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    clearType: { type: String, required: true },
    label: { type: String, default: "Clear All" },
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "mobile", "mobile-header"].includes(v),
    },
  });

  const emit = defineEmits(["clear"]);
  const requestClear = inject("requestClear", null);

  const buttonClass = computed(() => {
    const base = "button is-small is-danger is-outlined";
    switch (props.variant) {
      case "mobile":
        return `${base} has-white-bg`;
      case "mobile-header":
        return "button is-danger is-light is-rounded has-white-bg mobile-header-action";
      default:
        return `${base} section-clear-btn`;
    }
  });

  function handleClick() {
    if (requestClear) {
      requestClear(props.clearType);
    } else {
      emit("clear", props.clearType);
    }
  }
</script>
